import Button from 'components/_UI/Button';
import Fieldset from 'components/_UI/Fieldset';
import Icon from 'components/_UI/Icon';
import InputWithAutocomplete from 'components/_UI/InputWithAutocomplete';
import Text from 'components/_UI/Text';
import React, { useState } from 'react'
import { Filter, Search } from 'lucide-react';
import styled from 'styled-components'
import { FullyCentered } from 'styled/alignment/Center';
import { Column } from 'styled/alignment/Column';
import { Row } from 'styled/alignment/Row'
import colors from 'theme/colors';

export default function HeaderFilters({ onFilterClick, onSearchSubmit, activeFilterCount = 0, onInputClick }) {
    const [searchValue, setSearchValue] = useState('');

    function handleSearchClick() {
        if (onInputClick) {
            onInputClick();
            return;
        }
        if (onSearchSubmit) onSearchSubmit(searchValue);
    }

    return (
        <Container>
            {/* <Inputs> */}
            {/* <Column>
                    <Text name='small' paddingBottom={0} color={colors.nightDark} type='bold'>O que</Text>
                    <Text name='small' paddingBottom={0} color={colors.nightLight} paddingTop={'2px'} >O que</Text>
                    </Column>

                <Column>
                <Text name='small' paddingBottom={0} color={colors.nightDark} type='bold'>Onde</Text>
                <Text name='small' paddingBottom={0} color={colors.nightLight} paddingTop={'2px'} >Onde em pelotas</Text>
                </Column>

                <Column>
                    <Text name='small' paddingBottom={0} color={colors.nightDark} type='bold'>Categoria</Text>
                    <Text name='small' paddingBottom={0} color={colors.nightLight} paddingTop={'2px'} >Fenadoce 2025</Text>
                </Column> */}
            {/* </Inputs> */}

            <StyledSearchInput $clickable={!!onInputClick} onClick={onInputClick || undefined}>
                <Fieldset
                    placeholder='Pesquisar'
                    onChangeValue={onInputClick ? undefined : setSearchValue}
                    readOnly={!!onInputClick}
                    onKeyUp={onInputClick ? undefined : (e) => {
                        if (e.key === 'Enter' && onSearchSubmit) {
                            onSearchSubmit(searchValue);
                        }
                    }}
                />
                <SearchContainer onClick={onInputClick ? undefined : handleSearchClick}>
                    <Search color={`var(--home-accent, ${colors.occasionalPurple})`} size={15} />
                </SearchContainer>
            </StyledSearchInput>



            <ButtonContainer width='120px' marginLeft='10px'>
                <FilterButtonWrapper>
                    <Button category='roundedBorded' marginBottom={0} onClick={onFilterClick}>
                        <FullyCentered>
                            <Column width='24px' height='24px'>
                                <Icon name='filter' color={`var(--home-accent, ${colors.occasionalPurple})`} />
                            </Column>
                            <Text color={`var(--home-accent, ${colors.occasionalPurple})`} paddingBottom={0} marginLeft={'8px'} type='bold' >
                                Filtros
                            </Text>
                        </FullyCentered>
                    </Button>
                    {activeFilterCount > 0 && <ActiveDot>{activeFilterCount}</ActiveDot>}
                </FilterButtonWrapper>
            </ButtonContainer>

        </Container>
    )
}

const Container = styled(Row)`
    width: auto;
    align-items: center;
    justify-content: center;
`;

const Inputs = styled(Row)`
    width: 520px;
    border-radius: 30px;
    background-color: transparent;
    padding: 10px;
    position: relative;
    box-shadow: 0 2px 5px #ccc;
    border: 1px solid #ccc;
    /* border: 1px solid ${colors.secondaryPurple}; */

    div{
        border-right: 1px solid ${colors.night};
        padding: 0 10px;
        &:nth-child(3) {
            border-right: 0;
            padding-right: 50px;
        }
        &:last-child {
            border-right: 0;
        }
    }
`;

const SearchContainer = styled(FullyCentered)`
    position: absolute;
    width: 24px;
    height: 24px;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
`;

const ButtonContainer = styled(Column)`
    & button {
        border: 1px solid color-mix(in srgb, var(--home-accent, ${colors.occasionalPurple}) 38%, transparent);
        background-color: transparent;
        border-radius: 10px;
        &:hover {
            background-color: color-mix(in srgb, var(--home-accent, ${colors.occasionalPurple}) 6%, transparent) !important;
            border: 1px solid color-mix(in srgb, var(--home-accent, ${colors.occasionalPurple}) 50%, transparent) !important;
        }
    }
`;

const FilterButtonWrapper = styled.div`
    position: relative;
    display: inline-flex;
`;

const ActiveDot = styled.div`
    position: absolute;
    top: -6px;
    right: -6px;
    min-width: 18px;
    height: 18px;
    padding: 0 4px;
    border-radius: 9px;
    background: var(--home-accent, ${colors.occasionalPurple});
    border: 2px solid ${colors.neutralLight};
    color: ${colors.neutralLight};
    font-size: 10px;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
`;

const StyledSearchInput = styled(Row)`
    background: var(--home-search-bg, ${colors.occasionalPurple}14);
    border: 1px solid color-mix(in srgb, var(--home-accent, ${colors.occasionalPurple}) 25%, transparent);
    border-radius: 10px;
    position: relative;
    padding: 12px;
    padding-right: 40px;
    width: 180px;
    box-shadow: inset 0 1px 3px rgba(0,0,0,0.10);
    transition: border-color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease;
    ${({ $clickable }) => $clickable && `cursor: pointer;`}

    @media screen and (min-width: 1400px) {
        width: 300px;
    }

    &:focus-within {
        background: var(--home-search-bg, ${colors.occasionalPurple}20);
        border-color: color-mix(in srgb, var(--home-accent, ${colors.occasionalPurple}) 44%, transparent);
        box-shadow: inset 0 1px 3px rgba(0,0,0,0.10), 0 0 0 2px color-mix(in srgb, var(--home-accent, ${colors.occasionalPurple}) 7%, transparent);
    }

    & > div {
        padding: 0 !important;
        & > input {
            border: none !important;
            color: var(--home-accent, ${colors.occasionalPurple}) !important;
            background: transparent !important;
            &::placeholder {
                color: color-mix(in srgb, var(--home-accent, ${colors.occasionalPurple}) 73%, transparent) !important;
            }
        }
    }
`